import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import {
    getCategories as getCategoriesApi,
    getCategoryTree as getCategoryTreeApi,
    getCategoryProducts as getCategoryProductsApi,
    createCategory as createCategoryApi,
    updateCategory as updateCategoryApi,
    deleteCategory as deleteCategoryApi,
} from 'helpers/api/categories';
import { categoryApiResponseSuccess, categoryApiResponseError } from './actions';
import { CategoryActionTypes } from './constants';

function* getCategoriesSaga({ payload }: any): SagaIterator {
    try {
        const response = yield call(getCategoriesApi, payload);
        yield put(categoryApiResponseSuccess(CategoryActionTypes.GET_CATEGORIES, response.data));
    } catch (error: any) {
        yield put(categoryApiResponseError(CategoryActionTypes.GET_CATEGORIES, error?.message || error));
    }
}

function* getCategoryTreeSaga(): SagaIterator {
    try {
        const response = yield call(getCategoryTreeApi);
        yield put(categoryApiResponseSuccess(CategoryActionTypes.GET_CATEGORY_TREE, response.data));
    } catch (error: any) {
        yield put(categoryApiResponseError(CategoryActionTypes.GET_CATEGORY_TREE, error?.message || error));
    }
}

function* createCategorySaga({ payload }: any): SagaIterator {
    try {
        const response = yield call(createCategoryApi, payload);
        yield put(categoryApiResponseSuccess(CategoryActionTypes.CREATE_CATEGORY, response.data));
    } catch (error: any) {
        yield put(categoryApiResponseError(CategoryActionTypes.CREATE_CATEGORY, error?.message || error));
    }
}

function* updateCategorySaga({ payload }: any): SagaIterator {
    try {
        const { id, ...data } = payload;
        const response = yield call(updateCategoryApi, id, data);
        yield put(categoryApiResponseSuccess(CategoryActionTypes.UPDATE_CATEGORY, response.data));
    } catch (error: any) {
        yield put(categoryApiResponseError(CategoryActionTypes.UPDATE_CATEGORY, error?.message || error));
    }
}

function* deleteCategorySaga({ payload }: any): SagaIterator {
    try {
        yield call(deleteCategoryApi, payload.id);
        yield put(categoryApiResponseSuccess(CategoryActionTypes.DELETE_CATEGORY, { id: payload.id }));
    } catch (error: any) {
        yield put(categoryApiResponseError(CategoryActionTypes.DELETE_CATEGORY, error?.message || error));
    }
}

function* getCategoryProductsSaga({ payload }: any): SagaIterator {
    try {
        const { id, ...params } = payload;
        const response = yield call(getCategoryProductsApi, id, params);
        yield put(categoryApiResponseSuccess(CategoryActionTypes.GET_CATEGORY_PRODUCTS, response.data));
    } catch (error: any) {
        yield put(categoryApiResponseError(CategoryActionTypes.GET_CATEGORY_PRODUCTS, error?.message || error));
    }
}

function* watchGetCategories() {
    yield takeEvery(CategoryActionTypes.GET_CATEGORIES, getCategoriesSaga);
}

function* watchGetCategoryTree() {
    yield takeEvery(CategoryActionTypes.GET_CATEGORY_TREE, getCategoryTreeSaga);
}

function* watchCreateCategory() {
    yield takeEvery(CategoryActionTypes.CREATE_CATEGORY, createCategorySaga);
}

function* watchUpdateCategory() {
    yield takeEvery(CategoryActionTypes.UPDATE_CATEGORY, updateCategorySaga);
}

function* watchDeleteCategory() {
    yield takeEvery(CategoryActionTypes.DELETE_CATEGORY, deleteCategorySaga);
}

function* watchGetCategoryProducts() {
    yield takeEvery(CategoryActionTypes.GET_CATEGORY_PRODUCTS, getCategoryProductsSaga);
}

function* categorySaga() {
    yield all([
        fork(watchGetCategories),
        fork(watchGetCategoryTree),
        fork(watchGetCategoryProducts),
        fork(watchCreateCategory),
        fork(watchUpdateCategory),
        fork(watchDeleteCategory),
    ]);
}

export default categorySaga;
